import React, { Component } from 'react'
import classNames from 'classnames'

import Accordion from '../Accordion'
import Button from '../Button'
import './StylesAccordion.css'

export default class StylesAccordion extends Component {
  renderTitle = (expanded = false) => {
    return (
      <div className="edit-styles-accordion-title">
        <Button outlined focussed={expanded}>
          Edit Styles
        </Button>
      </div>
    )
  }

  renderChildren = () => {
    const { renderChildren } = this.props

    return (
      <div className="edit-styles-accordion-children-wrapper">
        {renderChildren()}
      </div>
    )
  }

  render() {
    const { spaced } = this.props

    return (
      <Accordion
        hideCarret
        className={classNames(
          'edit-styles-accordion',
          spaced && 'edit-styles-accordion-spaced'
        )}
        title={this.renderTitle()}
        expandedTitle={this.renderTitle(true)}
        renderChildren={this.renderChildren}
      />
    )
  }
}
